import { render, staticRenderFns } from "./ParametersReturn.vue?vue&type=template&id=05c90400&scoped=true&"
import script from "./ParametersReturn.vue?vue&type=script&lang=js&"
export * from "./ParametersReturn.vue?vue&type=script&lang=js&"
import style0 from "./ParametersReturn.vue?vue&type=style&index=0&id=05c90400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c90400",
  null
  
)

export default component.exports